/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Collaborations16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 10.5c1.21 0 2.293.413 3.232 1.096.56.407.953.817 1.168 1.104a.5.5 0 11-.8.6 3.277 3.277 0 00-.234-.267 5.408 5.408 0 00-.722-.629C8.864 11.837 7.979 11.5 7 11.5c-.979 0-1.865.337-2.644.904-.275.2-.517.415-.722.63-.083.084-.16.173-.234.266a.5.5 0 01-.8-.6c.215-.287.607-.697 1.168-1.104C4.707 10.913 5.79 10.5 7 10.5zm0-6a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12.004 2a.5.5 0 01.5.5v1h.996a.5.5 0 010 1h-.996v1a.5.5 0 01-1 0v-1H10.5a.5.5 0 010-1h1.004v-1a.5.5 0 01.5-.5z"
            fill={vars.bdlGray}
        />
    </AccessibleSVG>
);

export default Collaborations16;
